import IComponent from "components/commons/IComponent";
import "./ColorPicker.scoped.css";
import { ChromePicker } from "react-color";

class ClassName extends IComponent {
  constructor(props) {
    super(props);
    this.state = {
      color: props.color || "#FFFFFF",
      showPicker: false,
    };
  }
  componentDidMount() {}
  componentWillUnmount() {}
  rgbaObjectToCssRgba(color) {
    return `rgba(${color.r},${color.g},${color.b},${color.a})`;
  }
  render() {
    let { color, showPicker } = this.state;
    return (
      <div className="ColorPickerContainer">
        <div
          className="ColorBlock"
          style={{ backgroundColor: this.rgbaObjectToCssRgba(color) }}
          onClick={() => this.setState({ showPicker: true })}
        />
        {showPicker && (
          <div
            className="ComponentContainer"
            onMouseLeave={() => this.setState({ showPicker: false })}
          >
            <ChromePicker
              color={color}
              onChange={(newColor) => {
                this.setState({ color: newColor.rgb });
                this.props.onChange && this.props.onChange(newColor.rgb);
              }}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ClassName;
